import { render, staticRenderFns } from "./TheLoader.vue?vue&type=template&id=32b1b18a&scoped=true&"
import script from "./TheLoader.vue?vue&type=script&lang=js&"
export * from "./TheLoader.vue?vue&type=script&lang=js&"
import style0 from "./TheLoader.vue?vue&type=style&index=0&id=32b1b18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1b18a",
  null
  
)

export default component.exports